import { render, staticRenderFns } from "./ContactHistoryItem.vue?vue&type=template&id=1dd73e87&scoped=true"
import script from "./ContactHistoryItem.vue?vue&type=script&lang=js"
export * from "./ContactHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./ContactHistoryItem.vue?vue&type=style&index=0&id=1dd73e87&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd73e87",
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QItemSection,QIcon,QSeparator,QItemLabel,QTooltip,QBadge});
